<ng-container *ngIf="dataReady$ | async">
  <om-navbar-desktop
    class="d-none d-md-block"
    [currentUser]="currentUser$ | async"
    [principalUser]="principalUser$ | async"
    [targetUsers]="targetUsers$ | async"
    [canBookVisit]="canBookVisit$ | async"
    [canRegisterKid]="canRegisterKid$ | async"
    [canSelectPcp]="canSelectPcp$ | async"
    [enrolledInMindsetPlus]="enrolledInMindsetPlus$ | async"
    [inactiveMembership]="inactiveMembership$ | async"
    [limitedAccessMembership]="limitedAccessMembership$ | async"
    [inviteCta]="inviteCta"
    [displayInviteCta]="displayInviteCta$ | async"
    [limitedAccessUpgradeMembershipEnabled]="limitedAccessUpgradeMembershipEnabled$ | async"
    [shouldShowUpgradeButton]="shouldShowUpgradeButton$ | async"
    [scheduleVisitQueryParams]="scheduleVisitQueryParams$ | async"
    (principalUserClicked)="resetTargetUser()"
    (targetUserClicked)="setTargetUser($event)"
  ></om-navbar-desktop>
  <om-navbar-mobile
    class="d-block d-md-none"
    [currentUser]="currentUser$ | async"
    [principalUser]="principalUser$ | async"
    [targetUsers]="targetUsers$ | async"
    [canBookVisit]="canBookVisit$ | async"
    [canRegisterKid]="canRegisterKid$ | async"
    [canSelectPcp]="canSelectPcp$ | async"
    [enrolledInMindsetPlus]="enrolledInMindsetPlus$ | async"
    [inactiveMembership]="inactiveMembership$ | async"
    [limitedAccessMembership]="limitedAccessMembership$ | async"
    [inviteCta]="inviteCta"
    [displayInviteCta]="displayInviteCta$ | async"
    [limitedAccessUpgradeMembershipEnabled]="limitedAccessUpgradeMembershipEnabled$ | async"
    [shouldShowUpgradeButton]="shouldShowUpgradeButton$ | async"
    [scheduleVisitQueryParams]="scheduleVisitQueryParams$ | async"
    (principalUserClicked)="resetTargetUser()"
    (targetUserClicked)="setTargetUser($event)"
  ></om-navbar-mobile>
</ng-container>
